//React
import React, { lazy, Suspense } from "react";
import { Provider } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";
//store
import store from "store";
//Paths
import ROUTE_PATH from "./paths";
//Utils
import { history } from "utils";
//Components
import { Loader } from "components";
//Containers
//Website
import {
  //Sample
  Landing,
  Actions,
  //General
  FAQ,
  TNC,
  DetailedFaq,
  PrivacyPolicy,
  AboutUs,
  ContactUs,
  Pricing,
  NewLanding,
  Help,
  MobileWebsite,
  HelpNew,
  // Default
  Default,
} from "containers";

import Signup from "../containers/Signup";

/* Dashboard screens */
const SignupLogin = lazy(
  () =>
    import(/* webpackPrefetch: true */ "../containers/Dashboard/SignupLogin")
);
const Home = lazy(() => import("../containers/Dashboard/Home"));
const Activity = lazy(() => import("../containers/Dashboard/Activity"));
const Application = lazy(() => import("../containers/Dashboard/Application"));
const CreateApplication = lazy(
  () => import("../containers/Dashboard/CreateApplication")
);
const ApplicationDetails = lazy(
  () => import("../containers/Dashboard/ApplicationDetails")
);
const Profile = lazy(() => import("../containers/Dashboard/Profile"));
const Organization = lazy(() => import("../containers/Dashboard/Organization"));

/* Docs screens */
const DocsHome = lazy(
  () => import(/* webpackPrefetch: true */ "../containers/Docs/Home")
);
const DocsApiReference = lazy(() => import("../containers/Docs/ApiReference"));
const DocsAndroid = lazy(() => import("../containers/Docs/Android"));
const DocsFlutter = lazy(() => import("../containers/Docs/Flutter"));
const DocsiOS = lazy(() => import("../containers/Docs/iOS"));
const DocsJavascript = lazy(() => import("../containers/Docs/Javascript"));
const DocsSdkHome = lazy(() => import("../containers/Docs/SdkHome"));
const Demo = lazy(() => import("../containers/Demo"));
const ProductHunt = lazy(() => import("../containers/ProductHunt"));
const Tanmay = lazy(() => import("../containers/Tanmay"));
const Auth = lazy(() => import("../containers/Auth"));
const Help1 = lazy(() => import("../containers/Help1"));
const Wordpress = lazy(() => import("../containers/Plugins/Wordpress"));
// Platforms
const PlatformHome = lazy(() => import("../containers/Platforms/Home"));
const Javascript = lazy(() => import("../containers/Platforms/Javascript"));
const Android = lazy(() => import("../containers/Platforms/Android"));
const ReactJS = lazy(() => import("../containers/Platforms/ReactJS"));
const Angular = lazy(() => import("../containers/Platforms/Angular"));
//Routes
const Routes: React.FC = () => (
  <Provider store={store}>
    <Suspense fallback={<Loader isLoading={true} />}>
      <Router history={history}>
        <Switch>
          {/* Sample */}
          <Route
            path={ROUTE_PATH.SAMPLES.LANDING}
            exact
            component={MobileWebsite}
          />
          <Route
            path={ROUTE_PATH.SAMPLES.NEW_LANDING}
            exact
            component={NewLanding}
          />
          <Route path={ROUTE_PATH.SAMPLES.ACTIONS} component={Actions} />
          {/* General */}
          <Route path={ROUTE_PATH.GENERAL.DEMO} component={Demo} />
          <Route path={ROUTE_PATH.GENERAL.TANMAY} component={Tanmay} />
          <Route
            path={ROUTE_PATH.GENERAL.PRODUCT_HUNT}
            component={ProductHunt}
          />
          <Route path={ROUTE_PATH.GENERAL.FAQ} component={FAQ} />
          <Route path={ROUTE_PATH.GENERAL.ABOUT_US} component={AboutUs} />
          <Route path={ROUTE_PATH.GENERAL.CONTACT_US} component={ContactUs} />
          <Route path={ROUTE_PATH.GENERAL.PRICING} component={Pricing} />
          <Route path={ROUTE_PATH.GENERAL.TNC} component={TNC} />
          <Route path={ROUTE_PATH.GENERAL.HELP} component={HelpNew} />
          <Route path={ROUTE_PATH.GENERAL.HELP_NEW} component={HelpNew} />
          <Route
            path={ROUTE_PATH.GENERAL.PRIVACY_POLICY}
            component={PrivacyPolicy}
          />
          <Route
            path={ROUTE_PATH.GENERAL.DETAILED_FAQ}
            component={DetailedFaq}
          />
          {/* Dashboard */}
          {/* Signup page removal */}
          {/* <Route
            path={ROUTE_PATH.DASHBOARD.SIGNUP_LOGIN}
            component={SignupLogin}
          /> */}
          <Route path={ROUTE_PATH.DASHBOARD.HOME} component={Home} />
          <Route path={ROUTE_PATH.DASHBOARD.ACTIVITY} component={Activity} />
          <Route
            path={ROUTE_PATH.DASHBOARD.APPLICATION}
            component={Application}
          />
          <Route
            path={ROUTE_PATH.DASHBOARD.CREATE_APPLICATION}
            component={CreateApplication}
          />
          <Route
            path={ROUTE_PATH.DASHBOARD.APPLICATION_DETAILS}
            component={ApplicationDetails}
          />
          <Route path={ROUTE_PATH.DASHBOARD.PROFILE} component={Profile} />
          <Route
            path={ROUTE_PATH.DASHBOARD.ORGANIZATION}
            component={Organization}
          />
          {/* Docs */}
          <Route path={`${ROUTE_PATH.DOCS.HOME}`} component={DocsHome} />
          <Route
            path={`${ROUTE_PATH.DOCS.API_REFERENCE}`}
            component={DocsApiReference}
          />
          <Route
            path={`${ROUTE_PATH.DOCS.SDK.ANDROID}`}
            component={DocsAndroid}
          />
          <Route path={`${ROUTE_PATH.DOCS.SDK.IOS}`} component={DocsiOS} />
          <Route
            path={`${ROUTE_PATH.DOCS.SDK.JAVASCRIPT}`}
            component={DocsJavascript}
          />
          <Route
            path={`${ROUTE_PATH.DOCS.SDK.FLUTTER}`}
            component={DocsFlutter}
          />
          <Route path={`${ROUTE_PATH.DOCS.SDK.HOME}`} component={DocsSdkHome} />
          <Route path={`${ROUTE_PATH.SIGNUP}`} component={Signup} />

          {/* Plugins */}
          <Route path={ROUTE_PATH.PLUGINS.WORDPRESS} component={Wordpress} />

          {/* JS */}
          <Route path={ROUTE_PATH.GENERAL.AUTH} component={Auth} />
          <Route path={ROUTE_PATH.GENERAL.Help1} component={Help1} />
          <Route
            path={ROUTE_PATH.GENERAL.MOBILE_WEBSITE}
            component={MobileWebsite}
          />

          {/* Platforms */}
          <Route path={ROUTE_PATH.PLATFORM.HOME} component={PlatformHome} />
          <Route path={ROUTE_PATH.PLATFORM.JAVASCRIPT} component={Javascript} />
          <Route path={ROUTE_PATH.PLATFORM.ANDROID} component={Android} />
          <Route path={ROUTE_PATH.PLATFORM.REACT_JS} component={ReactJS} />
          <Route path={ROUTE_PATH.PLATFORM.ANGULAR} component={Angular} />

          {/* Default */}
          <Route path="*" component={Default} />
        </Switch>
      </Router>
    </Suspense>
  </Provider>
);

export default React.memo(Routes);
